import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode, faBarCode, faKeyboard, faCartShopping, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import './BeSure.css';

const BeSureGenerateCode = () => {
  const [batchNumber, setBatchNumber] = useState('');
  const [batchCode, setBatchCode] = useState('');
  const [batchSize, setBatchSize] = useState('');
  const [mfgDate, setMfgDate] = useState('');
  const [expDate, setExpDate] = useState('');
  const [productName, setProductName] = useState('');
  const [productBrand, setProductBrand] = useState('');
  const [numCodes, setNumCodes] = useState('');
  const [generatedCodes, setGeneratedCodes] = useState([]);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const generateCodes = () => {
    setError('');
    setMessage('');

    if (!batchNumber || !batchCode || !batchSize || !mfgDate || !expDate || !productName || !productBrand || !numCodes) {
      setError('All fields are required.');
      return;
    }

    if (batchSize < 10 || batchSize > 9999) {
      setError('Batch Size must be between 10 and 9999.');
      return;
    }

    if (numCodes < 1 || numCodes > batchSize) {
      setError('Number of product codes must be between 1 and Batch Size.');
      return;
    }

    const newCodes = [];
    for (let i = 0; i < numCodes; i++) {
      const serialNumber = String(i + 1).padStart(5, '0'); // 5-digit serial number
      const productCode = `BS${batchCode}${serialNumber}`;
      newCodes.push({
        productCode,
        productName,
        productBrand,
        batchNumber,
        mfgDate: new Date(mfgDate),
        expDate: new Date(expDate),
        productBrief: `Generated code ${productCode} for batch ${batchNumber}`,
      });
    }

    setGeneratedCodes(newCodes);
    setMessage('Product codes generated successfully!');
  };

  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>BeSure - Generate Product Code</h2>
      </div>
      <div className="m-auto my-2 p-2 px-4 border-2 shadow-md rounded-md md:w-7/12 w-full">
        <h1 className='text-3xl font-bold text-white mb-4'>Generate Product Codes</h1>
        <div className='max-w-md'>
          <div className='flex items-center mb-4'>
            <FontAwesomeIcon icon={faKeyboard} className='text-gray-400 mr-2' />
            <input
              type='text'
              placeholder='Batch Number'
              value={batchNumber}
              onChange={(e) => setBatchNumber(e.target.value)}
              className='w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300'
            />
          </div>
          <div className='flex items-center mb-4'>
            <FontAwesomeIcon icon={faQrcode} className='text-gray-400 mr-2' />
            <input
              type='text'
              placeholder='Batch Code (7 characters)'
              value={batchCode}
              onChange={(e) => setBatchCode(e.target.value)}
              className='w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300'
            />
          </div>
          <div className='flex items-center mb-4'>
            <FontAwesomeIcon icon={faQrcode} className='text-gray-400 mr-2' />
            <input
              type='number'
              placeholder='Batch Size (10-9999)'
              value={batchSize}
              onChange={(e) => setBatchSize(e.target.value)}
              className='w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300'
            />
          </div>
          <div className='flex items-center mb-4'>
            <FontAwesomeIcon icon={faQrcode} className='text-gray-400 mr-2' />
            <input
              type='date'
              value={mfgDate}
              onChange={(e) => setMfgDate(e.target.value)}
              className='w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300'
            />
          </div>
          <div className='flex items-center mb-4'>
            <FontAwesomeIcon icon={faQrcode} className='text-gray-400 mr-2' />
            <input
              type='date'
              value={expDate}
              onChange={(e) => setExpDate(e.target.value)}
              className='w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300'
            />
          </div>
          <div className='flex items-center mb-4'>
            <FontAwesomeIcon icon={faCartShopping} className='text-gray-400 mr-2' />
            <input
              type='text'
              placeholder='Product Name'
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              className='w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300'
            />
          </div>
          <div className='flex items-center mb-4'>
            <FontAwesomeIcon icon={faCartShopping} className='text-gray-400 mr-2' />
            <input
              type='text'
              placeholder='Brand'
              value={productBrand}
              onChange={(e) => setProductBrand(e.target.value)}
              className='w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300'
            />
          </div>
          <div className='flex items-center mb-4'>
            <FontAwesomeIcon icon={faPlusSquare} className='text-gray-400 mr-2' />
            <input
              type='number'
              placeholder='Number of Product Codes'
              value={numCodes}
              onChange={(e) => setNumCodes(e.target.value)}
              className='w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300'
            />
          </div>
          <button
            onClick={generateCodes}
            className='w-full py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700'
          >
            Generate Now
          </button>
          {message && <p className='mt-4 text-green-500'>{message}</p>}
          {error && <p className='mt-4 text-red-500'>{error}</p>}
        </div>
        {generatedCodes.length > 0 && (
          <div className='mt-6 w-full max-w-md'>
            <h2 className='text-xl font-bold text-white mb-2'>Generated Product Codes</h2>
            <ul className='list-disc pl-5'>
              {generatedCodes.map((code, index) => (
                <li key={index} className='text-gray-300'>{code.productCode}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </MainLayout>
  );
};

export default BeSureGenerateCode;
